import React from 'react';

const SearchBox = ({searchfield, searchChange}) => {
    return (
        <div className='pa2'>
            <input 
                className='pa3 ba b--green bg-lightest-blue'
                aria-label="Search Robots"
                placeholder='search robots' 
                onChange={searchChange}
            />
            <br/>
        </div>
    );

}

export default SearchBox;